import { ActionType } from '../../models/Action';
/**
 * Serviço para gerenciar dados do payment block
 * Segue o padrão do Builder para carregar/salvar dados das SetVariable actions
 */
export class PaymentDataService {
    /**
     * Recupera dados de configuração da SetVariable action
     */
    static getConfigurationData(state) {
        return this.getVariableValue(state, 'configurationData');
    }
    /**
     * Recupera dados do payment method da SetVariable action
     */
    static getPaymentMethodData(state) {
        return this.getVariableValue(state, 'paymentMethodData');
    }
    /**
     * Recupera dados de customização da SetVariable action
     */
    static getCustomizeData(state) {
        return this.getVariableValue(state, 'customizeData');
    }
    /**
     * Atualiza dados de configuração na SetVariable action
     */
    static updateConfigurationData(state, data) {
        this.updateVariableValue(state, 'configurationData', data);
    }
    /**
     * Atualiza dados do payment method na SetVariable action
     */
    static updatePaymentMethodData(state, data) {
        this.updateVariableValue(state, 'paymentMethodData', data);
    }
    /**
     * Atualiza dados de customização na SetVariable action
     */
    static updateCustomizeData(state, data) {
        this.updateVariableValue(state, 'customizeData', data);
    }
    /**
     * Método auxiliar para recuperar valor de uma SetVariable action
     */
    static getVariableValue(state, variableName) {
        if (!state || !state.$leavingCustomActions)
            return null;
        const setVariableAction = state.$leavingCustomActions.find(action => action.type === ActionType.SetVariable &&
            action.settings &&
            action.settings.variable === variableName);
        if (setVariableAction && setVariableAction.settings && setVariableAction.settings.value) {
            try {
                // Se o valor é uma string JSON, parseia ela
                if (typeof setVariableAction.settings.value === 'string') {
                    // Se começa com { ou [, é JSON
                    if (setVariableAction.settings.value.trim().startsWith('{') ||
                        setVariableAction.settings.value.trim().startsWith('[')) {
                        return JSON.parse(setVariableAction.settings.value);
                    }
                    // Se é string vazia ou '{}', retorna null
                    if (setVariableAction.settings.value.trim() === '' ||
                        setVariableAction.settings.value.trim() === '{}') {
                        return null;
                    }
                }
                return setVariableAction.settings.value;
            }
            catch (error) {
                // Silently handle parse errors
                return null;
            }
        }
        return null;
    }
    /**
     * Método auxiliar para atualizar valor de uma SetVariable action
     */
    static updateVariableValue(state, variableName, data) {
        if (!state || !state.$leavingCustomActions)
            return;
        const setVariableAction = state.$leavingCustomActions.find(action => action.type === ActionType.SetVariable &&
            action.settings &&
            action.settings.variable === variableName);
        if (setVariableAction && setVariableAction.settings) {
            // Atualiza o valor da variável com os dados da tab (pode conter {{variáveis}})
            setVariableAction.settings.value = JSON.stringify(data);
        }
    }
}
// Export default para compatibilidade
const paymentDataService = PaymentDataService;
export default paymentDataService;
